import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { validaSoloNumero } from "../../../util/varios";
import CatalogoUbicacion from "../../../catalogos/catalogoUbicacion";

import { 
  DangerButton, 
  InfoButton, 
  PrimaryButton, 
  SuccessButton, 
  WarningButton 
} from '../../../ui/buttons/Button';

export const GestionarUbicaciones = (props) => {
  var op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const accbtnubialmacen = "1111";
  const almacensel = JSON.parse(localStorage.getItem('idalmacen'));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtCodUbicacion = useRef();
  const txtDescripcion = useRef();
  const cmbAlmacen = useRef();
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [tituloHeader, setTituloHeader] = useState("Gestion Ubicación.");
  const [activate, setActivate] = useState(false);
  const [catalogoUbicacion, setCatalogoUbicacion] = useState(false);
  const [almacen, setAlmacen] = useState([]);
  const [body, setBody] = useState(null);
  const [habilitado, setHabilitado] = useState(true);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const onChange = (e) => {
    if (e.target.name === "descripcionubicacion") {
      e.target.value = e.target.value;
    } else {
      e.target.value = e.target.value;
    }
  };

  const procesarRegistro = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/comprasAlmacen/actUbicacion`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let ope = 0;

          if (!botones.incluir) {
            ope = 1;
          } else if (!botones.modificar) {
            ope = 2;
          } else if (!botones.eliminar) {
            ope = 3;
          }
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }

          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "ubicacion_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "almacen";
    let orden = "idalmacen";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setAlmacen(response.data);
            cmbAlmacen.current.value = almacensel ? almacensel : "";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarRegistro = (id) => {
    let campos = "*";
    let nomtab = "ubicacion";
    let nomid = "idubicacion";
    let nomid2 = "idalmacen";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${parseInt(almacensel)}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          txtDescripcion.current.value = "";
          if (response.data.length > 0) {
            txtCodUbicacion.current.value = id;
            txtDescripcion.current.value =
              response.data[0].descripcionubicacion.trim();
            //alert(response.data[0].idalmacen)
            cmbAlmacen.current.value = response.data[0].idalmacen;
            txtCodUbicacion.current.setAttribute("disabled", true);
            //if (!botones.modificar) {
              setBotones({ ...botones, catalogo: true });
            //}
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una ubicacion con este codigo",
              icono: "informacion",
            });
            txtCodUbicacion.current.value = "";
            txtDescripcion.current.value = "";
            //cmbAlmacen.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setActivate(false);
    setTituloHeader("Gestionar Ubicación.");
    setBody(null);
    setHabilitado(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
    });
    txtCodUbicacion.current.setAttribute("disabled", true);
    txtCodUbicacion.current.value = "";
    txtDescripcion.current.value = "";
    //cmbAlmacen.current.value = "";
    setVisibleBtn("visible");
  };

  const cancelar = () => {
    props.setShow(false);
    blanquear();
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtDescripcion.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar una descripción a la ubicacion",
          icono: "informacion",
        });
        txtDescripcion.current.focus();
        sigue = false;
      } else if (cmbAlmacen.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el almacen",
          icono: "informacion",
        });
        cmbAlmacen.current.focus();
        sigue = false;
      }
    }

    if (sigue) {
      let ope = 0;

      if (!botones.incluir) {
        ope = 1;
      } else if (!botones.modificar) {
        ope = 2;
      } else if (!botones.eliminar) {
        ope = 3;
      }

      var ubicacion = [];
      ubicacion.push({
        idubicacion:
          txtCodUbicacion.current.value === ""
            ? 0
            : txtCodUbicacion.current.value,
        descripcionubicacion: txtDescripcion.current.value.toUpperCase().trim(),
        idalmacen: cmbAlmacen.current.value,
      });

      setBody({
        operacion: ope,
        ubicacion: ubicacion,
      });

      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const cerrar = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    //props.setShow(false);
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };
  

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const validarUbicacion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistro(event.target.value);
      }
    }
  };

  const onCatalogoUbicacion = (values) => {
    setCatalogoUbicacion(false);
    seleccionarRegistro(values);
  };
  const onBotones = (op) => (e) => {
    e.preventDefault();
    if (op === 1) {
      if (
        accbtnubialmacen &&
        accbtnubialmacen.toString().substring(0, 1) === "1"
      ) {
        setVisibleBtn("hidden");
        setHabilitado(false);
        setTituloHeader("Incluir Ubicación.");
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
        });
        txtCodUbicacion.current.setAttribute("disabled", true);
        setTimeout(() => txtDescripcion.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accbtnubialmacen &&
        accbtnubialmacen.toString().substring(1, 2) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Editar Ubicación.");
        txtCodUbicacion.current.removeAttribute("disabled");
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
        });
        txtCodUbicacion.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accbtnubialmacen &&
        accbtnubialmacen.toString().substring(3, 4) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Eliminar Ubicación.");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
        });
        txtCodUbicacion.current.removeAttribute("disabled");
        txtCodUbicacion.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accbtnubialmacen &&
        accbtnubialmacen.toString().substring(2, 3) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Consultar Ubicación.");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
        });
        txtCodUbicacion.current.removeAttribute("disabled");
        txtCodUbicacion.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    } else if (op === 7) {
      setVisibleBtn("visible");
      cancelar();
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (almacensel !== null && parseInt(almacensel) > 0){
          cmbAlmacen.current.value = almacensel;
          seleccionarRegistros();
        } else {
          //setVisibleBtn("visible");
          setMensaje({
              mostrar: true,
              titulo: "Notificación.",
              texto: "Debe seleccionar un almacén primero",
              icono: "informacion",
          });
          //cancelar();
        }
        
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="m-0 fw-bold">Gestion de Ubicación</h3>
        <a
          href="#"
          ref={btnSalir}
          disabled={botones.salir}
          onClick={onBotones(7)}
          className="text-light fw-bold fs-6"
        >
          Salir<i className="fas fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 p-0 d-flex justify-content-between flex-wrap">
          <div className="col-4 m-0 mb-2 p-0 input-group input-group-sm">
            <label className="input-group-text">Código de Ubicación:</label>
            <input
              autoComplete="off"
              ref={txtCodUbicacion}
              disabled
              onKeyUp={validarUbicacion}
              onBlur={validarUbicacion}
              name="idubicacion"
              className="form-control fs-6"
            />
            <button
              disabled={botones.catalogo}
              onClick={() => setCatalogoUbicacion(true)}
              type="button"
              className="btn btn-success"
            >
              <i className="fas fa-search"></i>
            </button>
          </div>
          <div className="col-4 m-0 mb-2 p-0 input-group input-group-sm">
            <label className="input-group-text">Almacen:</label>
            <select
              ref={cmbAlmacen}
              name="almacen"
              className="form-select form-select-sm px-0 text-center"
              //disabled={habilitado}
              disabled={true}
              onChange={onChange}
            >
              <option value="">--</option>
              {almacen &&
                almacen.map((item, index) => (
                  <option key={index} value={item.idalmacen}>
                    
                    {item.descripcion}
                  </option>
                ))}
            </select>
          </div>
          <div className="w-100 col-12 m-0 mb-2 p-0 input-group input-group-sm">
            <label className="input-group-text">Descripción:</label>
            <textarea
              type="textarea"
              style={{ height: 70 }}
              autoComplete="off"
              disabled={habilitado}
              ref={txtDescripcion}
              onChange={onChange}
              name="descripcionubicacion"
              className="form-control text-uppercase fs-6"
            />
          </div>
        </div>
        <div className="col-12 m-0 p-0 d-flex justify-content-end gap-2">
          {visibleBtn === "visible" && (
            <>
              <PrimaryButton icon = 'fa-plus'
                disabled={botones.incluir}
                onClick={onBotones(1)}
              >
                Incluir
              </PrimaryButton>
              <InfoButton icon = 'fa-eye'
                disabled={botones.consultar}
                onClick={onBotones(4)}
              >
                Consultar
              </InfoButton>
              <WarningButton icon = 'fa-edit'
                disabled={botones.modificar}
                onClick={onBotones(2)}
              >
                Modificar
              </WarningButton>
              <DangerButton
                disabled={botones.eliminar}
                onClick={onBotones(3)}
              >
                Eliminar
              </DangerButton>
            </>
          )}
          {visibleBtn !== "visible" && 
            <>
              <SuccessButton
                disabled={botones.aceptar}
                onClick={onBotones(5)}
                ref={btnAcepta}
              >
                Aceptar
              </SuccessButton>
              <DangerButton
                disabled={botones.cancelar}
                onClick={onBotones(6)}
                ref={btnCancela}
              >
                Cancelar
              </DangerButton>
            </>
          }
        </div>
      </Modal.Body>
      <CatalogoUbicacion
        show={catalogoUbicacion}
        onHideCancelar={() => {
          setCatalogoUbicacion(false);
        }}
        onHideAceptaCatalogo={onCatalogoUbicacion}
        idalmacen={parseInt(almacensel)}  
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrar()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito." || mensaje.titulo === "Notificación."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate}></Dimmer>
    </Modal>
  );
};
